import { createFileRoute } from "@tanstack/react-router";
import type { Id } from "@convex/_generated/dataModel";
import { PlayerProfileScreen } from "@/features/night/players/PlayerProfileScreen";

export const Route = createFileRoute(
  "/_authenticated/leagues/$leagueId/players/$playerId",
)({
  component: LeaguePlayerProfilePage,
});

function LeaguePlayerProfilePage() {
  const { leagueId, playerId } = Route.useParams();
  return (
    <PlayerProfileScreen
      leagueId={leagueId as Id<"leagues">}
      playerId={playerId as Id<"players">}
    />
  );
}
